export default __webpack_public_path__ + "static/media/menu.ea34de3a.svg";